import _ from 'lodash'
import { defineComponent, h } from 'vue'
import { mapActions, mapState } from 'vuex'

// socket
import socket from '@/socket'

// contants
import { SOCKET_TYPES, SOCKET_ACTIONS, SOCKET_EVENTS } from '@/constants'

export default (component: any) => defineComponent({
  data() {
    return {
      moderationCode: '',
      isLoadingPresentation: true,
    }
  },
  computed: {
    ...mapState({
      presentation: (state: any) => state.presentation,
      questions: (state: any) => state.questions,
    }),
  },
  async mounted() {
    this.moderationCode = this.$route.params.moderationCode as string

    if (!this.moderationCode) {
      this.$router.push({
        name: 'NotFound',
      })
      return
    }

    socket.initialize()
    this.registerSocketEvents()
  },
  unmounted() {
    socket.offAny()
  },
  methods: {
    ...mapActions([
      'getPresentationAction',
      'getQuestionsAction',
      'setPresentationAction',
      'setQuestionsAction',
    ]),

    registerSocketEvents() {
      socket.on(SOCKET_EVENTS.CONNECT_AND_RECONNECT, () => this.handleSocketConnectAndReconnect())
      socket.on(SOCKET_EVENTS.CLEAR_QUESTION_SLIDE_DATA, () => this.setQuestionsAction([]))
      socket.on(SOCKET_EVENTS.CLEAR_PRESENTATION_DATA, () => this.setQuestionsAction([]))
      socket.onAny(this.handleSocketMessagesFromPresenterRoom)
    },

    async handleSocketConnectAndReconnect() {
      let presentation: any = null

      try {
        this.isLoadingPresentation = true
        presentation = await this.getPresentationAction(this.moderationCode)
        await this.getQuestionsAction(presentation.id)
        this.isLoadingPresentation = false
      } catch {
        this.$router.push({
          name: 'NotFound',
        })
        return
      }

      const presenterRoom = `${presentation.uniqueAccessCode}-presenter`
      socket.emit('join-presenter', presenterRoom)
    },

    handleQuestionChanged(action: string, data: any) {
      if (action === SOCKET_ACTIONS.QUESTION_CREATED) {
        this.setQuestionsAction([...this.questions, data])
        return
      }

      if (action === SOCKET_ACTIONS.QUESTION_UPDATED) {
        const newQuestions = this.questions.map((question: any) => {
          if (question.id === data.id) return data

          return question
        })
        this.setQuestionsAction(newQuestions)
      }
    },

    handlePresentationChanged(action: string, data: any) {
      if (
        action === SOCKET_ACTIONS.MODERATION_MODE_ENABLED
        || action === SOCKET_ACTIONS.MODERATION_MODE_CHANGED
      ) {
        this.handleModerationModeChanged(data)
        return
      }

      if (action === SOCKET_ACTIONS.PRESENTATION_CHANGED) {
        const { name } = data
        this.setPresentationAction({
          ...this.presentation,
          name: name || this.presentation.name,
        })
      }
    },

    handleSocketMessagesFromPresenterRoom(eventName: string, message: any) {
      const { type, action, data } = message

      if (type === SOCKET_TYPES.ONLINE_COUNT_CHANGED) {
        this.handleOnlineCountChanged(data)
        return
      }

      if (type === SOCKET_TYPES.QUESTIONS_CHANGED) {
        this.handleQuestionChanged(action, data)
        return
      }

      if (type === SOCKET_TYPES.PRESENTATION) {
        this.handlePresentationChanged(action, data)
      }
    },

    handleOnlineCountChanged: _.throttle(function callback(this: any, numberOfOnlineUser: number) {
      let onlineStatus = 'green'
      const percentLimit = (numberOfOnlineUser / this.presentation.limit)
        * 100
      if (percentLimit > 75 && percentLimit < 95) {
        onlineStatus = 'warning'
      }
      if (percentLimit >= 95) {
        onlineStatus = 'danger'
      }
      if (percentLimit <= 75) {
        onlineStatus = 'green'
      }
      const newPresentation = {
        ...this.presentation,
        onlineCount: numberOfOnlineUser,
        onlineStatus,
      }
      this.setPresentationAction(newPresentation)
    }, 1000),

    handleModerationModeChanged(data: boolean) {
      if (data) return

      this.$router.push({
        name: 'NotFound',
      })
    },
  },
  render() {
    return h(component, {
      ...this.$attrs,
      presentation: this.presentation,
      isInAPresentation: !!this.presentation.id,
      isLoadingPresentation: this.isLoadingPresentation,
    })
  },
})
